import axios from 'axios';
import {
  Message, MessageBox
} from 'element-ui';
import router from '@/router'
import { lib } from '../assets/js/lib'
import { aes } from '../assets/js/crypto'
import qs from 'qs'

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.BASE_API, // api的base_url
  timeout: 10000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {
  // Do something before request is sent
  // if (lib.cookie.get('Hpc-Platform-Token')) {
  //   config.headers["Authorization"] = 'Bearer ' + lib.cookie.get('Hpc-Platform-Token'); // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
  // }
  if (config.headers.loginFlag) {
    config.headers.contentType = 'application/x-www-form-urlencoded'
    config.data = qs.stringify(config.data)
  } else if (!config.headers.loginFlag && lib.cookie.get('Hpc-Platform-Token')) {
    config.headers.Authorization = "Bearer " + lib.cookie.get('Hpc-Platform-Token');
  }
  if (lib.cookie.get('HEAD-CLUSTER-NAME')) {
    config.headers['HEAD-CLUSTER-NAME'] = lib.cookie.get('HEAD-CLUSTER-NAME');
  }
  console.log(config);
  if (!config.decryptType || config.decryptType === 'PARAMS') {
    config.headers['Decrypt-Type'] = 'PARAMS';
  } else {
    config.headers['Decrypt-Type'] = 'BODY';
  }
  if (config.params) {
    if (!config.encrypt || config.encrypt == 'Y') {
      config.params = { encrypt: aes.en(JSON.stringify(config.params)) };
    }
  }
  console.log(config);
  if (config.data) {
    config.headers['Content-Type'] = "application/json; charset=utf-8";
    if (!config.encrypt || config.encrypt == 'Y') {
      config.data = { encrypt: aes.en(JSON.stringify(config.data)) };
    }
  }


  return config;
}, error => {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
    const res = response.data;
    if (response.data && response.data.code === 401) { // 401, token失效
      router.push({ name: 'login' })
      return response
    }
    if (response.status === 401 || res.status === 40101) {
      MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('FedLogOut').then(() => {
          location.reload(); // 为了重新实例化vue-router对象 避免bug
        });
      })
      return Promise.reject('error');
    }
    if (res.status === 40301) {
      Message({
        message: '当前用户无相关操作权限！',
        type: 'error',
        duration: 5 * 1000
      });
      return Promise.reject('error');
    }
    /**
     * 捕捉服务端返回的状态码为500的异常，统一框架层做处理*/
    if (res.status === 500) {
      const msg = res.message ? res.message : res.code;
      Message({
        message: msg,
        type: 'error',
        duration: 5 * 1000
      });
      return Promise.reject('error');
    }

    if (response.status !== 200 && res.status !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      });
    } else {
      return response.data;
    }
  },
  error => {
    let errorRs = ''
    if (error.request) {
      errorRs = error.request
    } else if (error.response) {
      errorRs = error.response
    }
    if (errorRs != '' && errorRs.status && errorRs.status === 401) {
      router.push({ name: 'login' })
    } else {
      return Promise.reject(error);
    }
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/comm/api/fetch.js